import { ArgTypes } from '../utils/ArgValidation';
import { checkTypesAndCast } from '../utils/CheckTypesAndCast';
import { genericRuleArgTypes } from './Rule';
import * as SingleInputAttributeRule from './SingleInputAttributeRule';

// com.tamr.recipe.models.flows.goldenRecords.LongestRule

export const TYPE = 'Longest';

export interface LongestRule extends SingleInputAttributeRule.AbstractSingleInputAttributeRule {
  type: typeof TYPE
}
export const argTypes = {
  type: ArgTypes.eq(TYPE as typeof TYPE),
  ...genericRuleArgTypes,
} as const;
export const fromJSON = checkTypesAndCast<LongestRule, typeof argTypes>(argTypes);

export const argType = ArgTypes.object.withShape(argTypes);
